import { GlobalStyles } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { clockClasses } from "@mui/x-date-pickers/ClockPicker"
import moment from "moment"
import { useIntl } from "react-intl"

const LocalizationProviderDatePicker = ({ locale, children }) => {
  const intl = useIntl()
  const amLabel = moment.localeData(locale).meridiem(1, 0, false)
  const pmLabel = moment.localeData(locale).meridiem(13, 0, false)

  return (
    <LocalizationProvider
      adapterLocale={locale}
      dateAdapter={AdapterMoment}
      localeText={{
        cancelButtonLabel: intl.formatMessage({ id: "action.cancel" }),
        okButtonLabel: intl.formatMessage({ id: "action.ok" }),
        clearButtonLabel: intl.formatMessage({ id: "action.clear" }),
      }}
    >
      <GlobalStyles
        styles={{
          [`.${clockClasses.amButton} .MuiTypography-root, .${clockClasses.pmButton} .MuiTypography-root`]: {
            fontSize: 0,
          },
          [`.${clockClasses.amButton} .MuiTypography-root::after`]: {
            content: JSON.stringify(amLabel),
            fontSize: "0.75rem",
          },
          [`.${clockClasses.pmButton} .MuiTypography-root::after`]: {
            content: JSON.stringify(pmLabel),
            fontSize: "0.75rem",
          },
        }}
      />
      {children}
    </LocalizationProvider>
  )
}

export default LocalizationProviderDatePicker
